<template>
  <section>
    <v-flex xs12 class="pa-2">
      <h1 class="heading">Total {{filteredCars .length}} cars</h1>
    </v-flex>
    <v-layout>
      <v-flex class="pa-2" sm12 md6 xl4 v-for="(car, index) in filteredCars" :key="index">
        <v-card elevation="0" class="bordered">
          <v-layout wrap class="layout">
            <v-flex xs12 class="sample-avt">
              <img v-if="car.images" :src="car.images" :alt="car['license-plate']" />
              <v-icon size="80px" dark>directions_car</v-icon>
              <label class="year" v-if="car.year && car.year.length < 5">{{car.year}}</label>
              <label class="reg-exp">
                <strong>REGIS EXP</strong>
                {{fullDate(car['regis-exp'])}}
              </label>
              <label class="status" v-if="car.status == 'UNLISTED'">{{car.status}}</label>
            </v-flex>
            <v-flex xs12>
              <v-card-text>
                <v-layout row wrap justify-space-between>
                  <v-flex shrink>
                    <h1 class="headline">{{car.make}} {{car.model}}</h1>
                  </v-flex>
                  <v-flex shrink>
                    <strong class="headline">{{car['license-plate']}}</strong>
                  </v-flex>
                </v-layout>

                <v-layout row nowrap justify-space-between style="clear: both">
                  <v-flex xs6>
                    <strong>LOC: {{car.loc}}</strong>
                    <span v-if="car['ga-id']">GA: {{car['ga-id']}}</span>
                  </v-flex>

                  <v-flex shrink style=" font-weight: normal;">
                    <p v-if="car['turo-id']">TURO: {{car['turo-id']}}</p>
                    <p>Vin: {{car.vin}} </p>
                  </v-flex>
                </v-layout>
                <v-layout row nowrap justify-space-between style="clear: both" v-if="(car.links && car.links.length)">
                  <v-flex span="12">
                    <strong>Short URL: </strong>
                    <v-text-field solo readonly hide-details :height="40" single-line v-model="car.links" @mousedown="() => copyToClipboard(car.links)"/>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-card-actions class="actions">
            <template v-if="!car.loc.includes('SAN') && !!car['turo-id']">
              <v-btn
                depressed
                tag="a"
                color="info"
                target="_blank"
                :disabled="!!!car['vehicle-type'] && !!!car['turo-id']"
                :href="car['vehicle-type'] && `https://turo.com/rentals/${car['vehicle-type'].toLowerCase()}s/${whiteSpace(car.make)}-${whiteSpace(car.model)}/${car['turo-id']}`"
              >TURO view</v-btn>
              <v-btn
                depressed
                tag="a"
                color="info"
                :disabled="!!!car['turo-id']"
                target="_blank"
                :href="`https://turo.com/en-us/your-car/${car['turo-id']}/availability`"
              >Calendar</v-btn>
              <v-btn
                depressed
                tag="a"
                color="info"
                :disabled="!!!car['turo-id']"
                target="_blank"
                :href="`https://turo.com/en-us/your-car/${car['turo-id']}/delivery`"
              >Location</v-btn>
              <v-btn
                depressed
                tag="a"
                color="info"
                :disabled="!!!car['turo-id']"
                target="_blank"
                :href="`https://turo.com/your-car/${car['turo-id']}/rentals`"
              >History</v-btn>
              <v-btn
                depressed
                tag="a"
                color="info"
                :disabled="!!!car['turo-id']"
                target="_blank"
                :href="`https://turo.com/your-car/${car['turo-id']}/preferences`"
              >Preference</v-btn>
            </template>
            <template v-if="!!car['ryde-id']">
              <v-btn
                depressed
                tag="a"
                target="_blank"
                color="pink accent-2"
                dark
                :href="`https://rydecars.com/car/${car['year']} ${car['model']}/${car['ryde-id']}`"
              >RYDE view</v-btn>
              <v-btn
                depressed
                tag="a"
                target="_blank"
                color="pink accent-2"
                dark
                :href="`https://rydecars.com/car-update/${car['ryde-id']}`"
              >Update</v-btn>
            </template>

            <template class="actions ga-actions" v-if="!!car['ga-id']">
              <v-btn
                depressed
                tag="a"
                color="warning"
                target="_blank"
                :disabled="car['ga-id'] === null"
                :href="`https://www.getaround.com/key/${car['ga-id']}`"
              >GA KEY</v-btn>
              <v-btn
                depressed
                tag="a"
                color="warning"
                target="_blank"
                :disabled="car['ga-id'] === null"
                :href="`https://www.getaround.com/edit/${car['ga-id']}`"
              >Edit</v-btn>
              <v-btn
                depressed
                tag="a"
                color="warning"
                target="_blank"
                :disabled="car['ga-id'] === null"
                :href="`https://www.getaround.com/edit/${car['ga-id']}#!location`"
              >Location</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="showMessage"
      color="info"
      :timeout="2000"
      vertical="vertical"
    >
      Copied!!
    </v-snackbar>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      showMessage: false,
    };
  },
  computed: {
    ...mapState(['cars']),
    filteredCars() {
      return this.cars.filter(car => !!car['license-plate']);
    },
  },
  mounted() {
    this.getData();
    this.$forceUpdate();
  },
  methods: {
    ...mapActions(['getData']),
    whiteSpace(input = 'gay') {
      const output = input.split(' ').join('');
      return output;
    },
    fullDate(input) {
      if (!input) return 'NA';
      const output = dayjs(input).format('MM/DD/YYYY');
      return output;
    },
    copyToClipboard(str) {
      console.log(str);
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.showMessage = true;
    },
  },
};
</script>

<style scoped>
.pull-right {
  float: right;
}
.layout {
  flex-flow: row wrap !important;
}
.headline {
  text-transform: uppercase;
  font-weight: bold;
  color: #3d3d3d;
}
.bordered {
  border: 1px solid #c2c2c2;
  border-radius: 8px;
  overflow: hidden;
}
.actions {
  flex-wrap: wrap;
  padding: 8px 4px;
  border-top: 1px solid rgb(235, 235, 235);
}
.actions >>> * {
  flex: 1;
  min-width: 120px;
}

.actions > * {
  margin: 4px 4px !important;
}
.sample-avt {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: lightgrey;
  flex-grow: 0;
  position: relative;
  overflow: hidden;
}
.sample-avt img {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: auto;
  transform: translateY(-50%);
}
.sample-avt label.year,
.sample-avt label.status,
.sample-avt label.reg-exp {
  z-index: 2;
  position: absolute;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  font-weight: 700;
}

.sample-avt label.status {
  bottom: 0;
  left: 0;
  color: #c62828;
}

.sample-avt label.year {
  top: 0;
  right: 0;
  border-radius: 0 0 0 8px;
  background-color: #c62828;
  color: white;
}
.sample-avt label.reg-exp {
  left: 20px;
  top: 20px;
  background-color: #fff;
  color: #c62828;
  border-radius: 8px;
  width: fit-content;
  text-align: center;
}
.sample-avt label.reg-exp strong {
  font-size: 1rem;
  display: block;
}
strong {
  display: block;
}
p {
  margin: 0;
}
</style>
